module.exports = __webpack_public_path__ + "static/media/galerija_2017 (20).eb297b16.jpg";